// import {useTheme } from '@mui/material/styles';

import Header from "../../Common/Header";
// import Diplomats from "./Diplomats/Diplomats";
import DiplomatsWebView from "./Diplomats/DiplomatsWebView";
import Home from "./Home/Home";
import MultiExchange from "./MultiExchange/MultiExchange";
import OpenAccount from "./OpenAccount/OpenAccount";
import UserFriendly from "./UserFriendly/UserFriendly";

import Refer from "./Refer/Refer";
import Connect from "./Connect/Connect";
import Incubation from "./Incubation/Incubation";
import Api from "./Api/Api";
import Footer from "./footer/Footer";
import MainFooter from "../../Common/Footer";
import Calculator from "./Calculator/Calculator";
import Sticky from "./StickyBar/Sticky";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function MainPage() {
  const location = useLocation();
  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Scroll to top on first load or refresh of home page
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <>
    <main>
      <Header />
      <Home />
      <OpenAccount />
      <MultiExchange />
      {/* <UserFriendly />
      <DiplomatsWebView /> */}
      <Refer />
      {/* <Connect />
      <Incubation /> */}
      {/* <Api /> */}
      {/* <Footer /> */}
      <Calculator />
      <Sticky />
      <MainFooter />
    </main>
    </>
  );
}
